import { resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7b6861c7"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Changing your preferences will refresh the page.", -1))
const _hoisted_2 = { class: "modal-contents" }
const _hoisted_3 = {
  class: "sr-only",
  role: "status",
  "aria-live": "polite"
}
const _hoisted_4 = { class: "submit" }
const _hoisted_5 = ["aria-disabled"]
const _hoisted_6 = {
  class: "error-message",
  role: "alert",
  "aria-live": "assertive"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_autocomplete_input = _resolveComponent("autocomplete-input")!
  const _component_badge_list = _resolveComponent("badge-list")!
  const _component_base_modal = _resolveComponent("base-modal")!

  return (_openBlock(), _createBlock(_component_base_modal, {
    "button-label": _ctx.buttonLabel,
    "modal-heading": _ctx.modalHeading,
    "initial-focus-id": `#${_ctx.autocompleteInputId}`
  }, {
    icon: _withCtx(() => [
      (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.icon)))
    ]),
    description: _withCtx(() => [
      _hoisted_1
    ]),
    contents: _withCtx(() => [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_autocomplete_input, {
          id: _ctx.autocompleteInputId,
          label: _ctx.label,
          "visually-hide-label": true,
          "action-label": `Add ${_ctx.dataType}`,
          source: _ctx.suggest,
          options: _ctx.options,
          onActionClicked: _ctx.onActionButtonClicked
        }, null, 8, ["id", "label", "action-label", "source", "options", "onActionClicked"]),
        _createVNode(_component_badge_list, {
          items: _ctx.selected,
          onRemoveItem: _ctx.removeSelectedItem
        }, null, 8, ["items", "onRemoveItem"]),
        _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.selectedListStatus), 1),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("button", {
            class: "primary-button",
            "aria-disabled": !_ctx.canSubmit,
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.submit && _ctx.submit(...args)))
          }, " Submit ", 8, _hoisted_5),
          _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.errorMessage), 1)
        ])
      ])
    ]),
    footer: _withCtx(() => [
      _createElementVNode("button", {
        class: "link-button",
        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.resetPreferences && _ctx.resetPreferences(...args)))
      }, " Reset my preferences ")
    ]),
    _: 1
  }, 8, ["button-label", "modal-heading", "initial-focus-id"]))
}